import * as React from 'react';

function NavExp(props) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 128 128"
            {...props}
        >
            <path
                d="M110.88,110.89a6.7,6.7,0,0,1-6.7,6.69H23.82a6.7,6.7,0,0,1-6.7-6.69h0A40.19,40.19,0,0,1,57.31,70.7H70.7A40.18,40.18,0,0,1,110.88,110.89Z"
                fill="currentColor"
            />
            <path
                d="M64,10.42A26.79,26.79,0,1,0,90.78,37.21h0A26.78,26.78,0,0,0,64,10.42Z"
                fill="currentColor"
            />
        </svg>
    );
}

export default NavExp;
